<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="16"
       height="16"
       viewBox="0 0 16 16"
       fill="none"
  >
    <path d="M8 9.28736L12.6669 4.53928L14 5.8956L8 12L2 5.8956L3.33312 4.53928L8 9.28736Z" fill="black" />
  </svg>
</template>
